import React, { useState, useEffect } from "react";
import BootstrapPagination from "react-bootstrap/Pagination";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Dropdown } from "react-bootstrap";
import { useCurrentBreakpointName } from "react-socks";
import Cookies from "js-cookie";
import { ReactComponent as ArrowLeft } from "assets/images/icons/ArrowLeft.svg";
import { ReactComponent as ArrowRight } from "assets/images/icons/ArrowRight.svg";

import "./Pagination.scss";

const Pagination = function ({
  pageSize,
  showingDataCount,
  totalData,
  totalPages,
  currentPage,
  className,
  pageClicked,
  setPageSize,
  showingResult,
  recordEnd,
  recordStart,
}) {
  const [pageArray, setPageArray] = useState([]);
  const breakpoint = useCurrentBreakpointName();

  useEffect(() => {
    let pageArr = [];
    if (totalPages > 1) {
      if (totalPages <= 9) {
        let i = 1;
        while (i <= totalPages) {
          pageArr.push(i);
          i += 1;
        }
      } else if (currentPage <= (breakpoint === "xsmall" ? 3 : 5))
        pageArr = breakpoint === "xsmall" ? [1, 2, 3, 4, 5, "", totalPages] : [1, 2, 3, 4, 5, 6, 7, 8, "", totalPages];
      else if (totalPages - currentPage <= 4)
        pageArr =
          breakpoint === "xsmall"
            ? [
                1,
                "",
                totalPages - 6,
                totalPages - 5,
                totalPages - 4,
                totalPages - 3,
                totalPages - 2,
                totalPages - 1,
                totalPages,
              ]
            : [
                1,
                "",
                totalPages - 7,
                totalPages - 6,
                totalPages - 5,
                totalPages - 4,
                totalPages - 3,
                totalPages - 2,
                totalPages - 1,
                totalPages,
              ];
      else
        pageArr =
          breakpoint === "xsmall"
            ? [1, "", currentPage - 1, currentPage, currentPage + 1, currentPage + 2, "", totalPages]
            : [
                1,
                "",
                currentPage - 3,
                currentPage - 2,
                currentPage - 1,
                currentPage,
                currentPage + 1,
                currentPage + 2,
                currentPage + 3,
                "",
                totalPages,
              ];
    }
    setPageArray(pageArr);
  }, [totalData, totalPages, currentPage, breakpoint]);

  return (
    <div className="d-flex flex-row w-100 flex-wrap justify-content-between align-items-center data-table-pagination">
      <div>
        {showingResult && (
          <span className="text-secondary font-b5">
            {totalPages > 1 ? (
              <FormattedMessage
                id="components.organisms.listing.showTotalResultOf"
                defaultMessage="Showing {recordStart}-{recordEnd} of {pageCount} results"
                values={{ recordStart, recordEnd, pageCount: totalData }} // pageCount = 201 (total response count)
              />
            ) : (
              <FormattedMessage
                id="components.organisms.listing.showTotalResult"
                defaultMessage="Showing {length} of {pageCount} results"
                values={{ length: showingDataCount, pageCount: totalData }} // pageCount = 201 (total response count)
              />
            )}
          </span>
        )}
      </div>
      <div className={className}>
        <BootstrapPagination>
          {pageArray.map((ele, i) => {
            const toReturn = [];

            if (i === 0) {
              toReturn.push(
                <div
                  className="cursor-pointer d-flex align-items-center pagination-arrow"
                  key="firstpage"
                  onClick={
                    currentPage === 1
                      ? () => {}
                      : () => {
                          pageClicked(1);
                        }
                  }
                >
                  <ArrowLeft />
                  <ArrowLeft />
                </div>,
              );

              toReturn.push(
                <div key="prevpage" className="cursor-pointer d-flex align-items-center pagination-arrow">
                  <ArrowLeft
                    onClick={
                      currentPage === 1
                        ? () => {}
                        : () => {
                            pageClicked(currentPage - 1);
                          }
                    }
                  />
                </div>,
              );
            }

            if (ele === "") toReturn.push(<BootstrapPagination.Ellipsis key={ele} className="cursor-none" />);
            else
              toReturn.push(
                <BootstrapPagination.Item
                  key={ele}
                  className="mx-1"
                  active={currentPage === ele}
                  onClick={
                    currentPage === ele
                      ? () => {}
                      : () => {
                          pageClicked(ele);
                        }
                  }
                >
                  {ele}
                </BootstrapPagination.Item>,
              );

            if (i === pageArray.length - 1) {
              toReturn.push(
                <div key="nextpage" className="cursor-pointer d-flex align-items-center pagination-arrow">
                  <ArrowRight
                    onClick={
                      currentPage === ele
                        ? () => {}
                        : () => {
                            pageClicked(currentPage + 1);
                          }
                    }
                  />
                </div>,
              );

              toReturn.push(
                <div
                  className="cursor-pointer d-flex align-items-center pagination-arrow"
                  key="lastpage"
                  onClick={
                    currentPage === ele
                      ? () => {}
                      : () => {
                          pageClicked(ele);
                        }
                  }
                >
                  <ArrowRight />
                  <ArrowRight />
                </div>,
              );
            }
            return toReturn;
          })}
        </BootstrapPagination>
      </div>
      {totalData > 10 && ( // pageCount = 201 (total response count)
        <div>
          <Dropdown
            drop="up"
            onSelect={(eventKey) => {
              Cookies.set("listing_sizeperpage", eventKey || "10");
              setPageSize(+(eventKey || 10)); // setPageSize
              pageClicked(1);
            }}
          >
            <Dropdown.Toggle variant="link" className="font-b3 p-0 rounded-0 pb-1 text-primary">
              <FormattedMessage
                id="components.organisms.listing.resultsPerPage"
                defaultMessage={`${pageSize} results per page`} // pageSize
                values={{ size: pageSize }} // pageSize
              />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item eventKey="10">10</Dropdown.Item>
              <Dropdown.Item eventKey="25">25</Dropdown.Item>
              <Dropdown.Item eventKey="100">100</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      )}
    </div>
  );
};

Pagination.propTypes = {
  totalPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  className: PropTypes.string,
  pageClicked: PropTypes.func.isRequired,
  totalData: PropTypes.number.isRequired,
  showingDataCount: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  setPageSize: PropTypes.func.isRequired,
  showingResult: PropTypes.bool,
  recordEnd: PropTypes.number.isRequired,
  recordStart: PropTypes.number.isRequired,
};

Pagination.defaultProps = {
  className: "",
  showingResult: false,
};

export default Pagination;
